@if (quote(); as quote) {
    <div class="d-grid gap-2">
        <a
            sfButton
            size="lg"
            color="success"
            routerLink="/diary/calendar"
            tooltip="Create an appointment associated with this quote"
            tooltipContainer="body"
            [disabled]="quote.accepted"
            [queryParams]="{
                smartQuoteId: quote.id,
                smartQuoteTotal: statistics().totalExcludeVat,
                smartQuoteDeposit: statistics().depositTotal,
                customerId: quote.customerId,
            }"
            icon="calendar"
            >{{ quote.accepted ? 'Accepted' : 'Schedule & Accept' }}</a
        >
    </div>
}

<div class="bg-body-secondary rounded-3 my-3 p-3">
    <h3>Quote Summary</h3>

    <div class="my-4">
        @if (customer(); as customer) {
            <div class="d-flex justify-content-between">
                <span class="fw-bold text-body-secondary"> Customer </span>
                <span class="fw-bold"
                    ><a routerLink="/customers/{{ customer.id }}">{{ customer.fullName }}</a></span
                >
            </div>
        }
        @if (quote(); as quote) {
            <div class="d-flex justify-content-between">
                <span class="fw-bold text-body-secondary">Quote Id#</span>
                <span class="fw-bold">{{ quote.id }}</span>
            </div>
            <div class="d-flex flex-column">
                <span class="fw-bold text-body-secondary">Address</span>
                <span class="fw-bold">
                    <fa-icon [icon]="['fas', 'location-dot']" class="text-primary me-1"></fa-icon>
                    {{ workAddress() }}
                </span>
            </div>
        }
    </div>

    <div class="d-flex justify-content-between">
        <span class="fw-bold text-body-secondary">Parts</span>
        <span class="fw-bold">
            @if (statistics().linesTermsTotal) {
                <span class="text-success small">({{ statistics().linesTermsTotal | currency }})</span>
            }
            {{ statistics().linesTotal | currency }}
        </span>
    </div>
    <div class="d-flex justify-content-between">
        <span class="fw-bold text-body-secondary">Labour</span>
        <span class="fw-bold"> {{ statistics().labourCost | currency }} </span>
    </div>
    <div class="d-flex justify-content-between">
        <span class="fw-bold text-body-secondary">Discount</span>
        <span class="fw-bold"> {{ statistics().discountAsPercentage + statistics().discountAsMoney | currency }} </span>
    </div>
    <div class="d-flex justify-content-between">
        <span class="fw-bold text-body-secondary">VAT</span>
        <span class="fw-bold"> {{ statistics().totalVat | currency }} </span>
    </div>
    <div class="d-flex justify-content-between">
        <span class="fw-bold text-body-secondary">Subtotal</span>
        <span class="fw-bold"> {{ statistics().totalExcludeVat | currency }} </span>
    </div>
    <div
        class="d-flex justify-content-between fw-bold border-top pt-2 mt-2 fs-4"
        [class.text-decoration-line-through]="freeOfCharge()">
        <span class="fw-bold text-body-secondary">Total</span>
        <span>
            {{ statistics().totalIncludeVat | currency }}
        </span>
    </div>

    @if (freeOfCharge()) {
        <p class="fw-bold text-danger mt-3 text-center">
            This quote is marked as Free of Charge. The customer will not be charged for this work.
        </p>
    }
</div>

@if (quote(); as quote) {
    <div class="d-grid gap-1">
        <button
            sfButton
            size="sm"
            color="warning"
            tooltip="Decline this quote on behalf of the customer"
            icon="xmark-circle"
            [disabled]="quote.declined"
            (click)="smartquoteHelperService.markQuoteAsDeclined()">
            Decline
        </button>
        <button
            sfButton
            size="sm"
            color="primary"
            tooltip="Copy this quote to a new quote (you will be automatically redirected to the new quote)"
            icon="copy"
            (click)="smartquoteHelperService.copySmartquote()">
            Copy
        </button>
        <button
            sfButton
            size="sm"
            color="danger"
            tooltip="Delete this quote"
            icon="trash"
            (click)="smartquoteHelperService.deleteSmartQuote()">
            Delete
        </button>
    </div>
}
